export const GRAY_BACKGROUND = "#f3f3f3";
export const BLUE = "#00aeef";
export const BLACK = "#3d3d3d";

export const VERY_LIGHT_GRAY = "#c1c1c1";
export const LIGHT_GRAY = "#929292";
export const GRAY_MIDDLE = "#737272";
export const GRAY = "#565656";
export const RED = "#ff4d4f";
export const TEXT_COLOR = "#4b5563";
